import React, { useState, useEffect } from 'react';
import HeaderAdmin from "../../Components/HeaderAdmin/Header";
import BuildAccordion from './BuildAccordion';
import BuildTab from './BuildTab2';
import { IoClose } from "react-icons/io5";
import { Modal } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { getbuildsheet, getbuildsheetdata, upateBuildSheetStatus } from "../../Api/buildsheetApi"
import Spinner from 'react-bootstrap/Spinner';
import { getCurrentUser } from "../../Api/auth";
import DriverWood from "./DriverWood";
import Hybrid from "./Hybrid";
import IronWedge from "./IronWedge";
import Wedge from "./Wedge";
import Putter from "./Putter";
import { StagingStGet } from '../../Api/StagingSt';
import { Link } from "react-router-dom";
import Loader2 from '../DashboardComponents/Loader/Loader2';
import { useHistory } from 'react-router-dom';
import { IoCloseSharp } from "react-icons/io5";
import { getNonEmptyStations } from '../../Api/StagingStationsApi'
import BuildTabBuildsheet from './BuildTabBuildsheet';
import { getInventoryByTypeWithShaftAndGrip, getallModeldatabymake, getInventoryByType, deletebuildsheet } from "../../Api/inventoryApi";
import { getremoteInquirydataApi } from "../../Api/iron"
import { getsingleprescription } from "../../Api/iron"
import { getPrescription } from "../../Api/prescriptionApis";
import BuildsheetInsights from "./BuildsheetInsights";
import Button from 'react-bootstrap/Button';

const initialPrescriptionState = {
    bounce: '',
    lieage: '',
    shaftweight: '',
    shaftflex: '',
    shaftprofile: '',
    gripSize: '',
    clubLength: '',
    swingWeight: '',
    optimalHeads: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalShafts: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalGrips: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    }
};

const initData = {
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    height_ft: "",
    height_in: "",
    wrist_to_floor: "",
    shoulder_to_wrist: "",
    elbow_to_wrist: "",
    fitter_name: "",
};

function UnassignedBuildSheet() {

    const [showinsight, setShowinsight] = useState(false);

    const history = useHistory();

    const goBack = () => {
        history.goBack();
    };

    const params = useParams();
    const id = params.id;

    const [isLoading, setIsLoading] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [show2, setShow2] = useState(false);
    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);

    const [show3, setShow3] = useState(false);

    const handleClose3 = () => setShow3(false);
    const handleShow3 = () => setShow3(true);

    const [show4, setShow4] = useState(false);

    const handleClose4 = () => setShow4(false);
    const handleShow4 = () => setShow4(true);

    const [show5, setShow5] = useState(false);

    const handleClose5 = () => setShow5(false);
    const handleShow5 = () => setShow5(true);

    const [show6, setShow6] = useState(false);

    const handleClose6 = () => setShow6(false);
    const handleShow6 = () => setShow6(true);

    const [buildsheetdata, setBuildSheetData] = useState([]);
    const [buildsheetnumber, setBuildSheetNumber] = useState(0);
    const [buildsheetnumbernew, setBuildSheetNumberNew] = useState(0);
    const [buildsheetid, setBuildSheetId] = useState(0);

    const [buildApiCall, setBuildApiCall] = useState(0);
    const [apicallupate, setApicallUpate] = useState(false);

    const [userdata, setUserdata] = useState('');
    const [closePopup, setClosePopup] = useState('');
    const [buildstatus, setBuildstatus] = useState(false);

    const [show02, setShow02] = useState(false);

    const handleClose02 = () => setShow02(false);
    const handleShow02 = () => setShow02(true);
    const [StagingStations, setStagingStations] = useState([]);
    const [nonEmptyStagingStation, setNonEmptyStagingStation] = useState([]);

    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState('Unassigned');
    const [selectedOptionsId, setselectedOptionsId] = useState('0');

    const [errors, setErrors] = useState([]);

    const [selectedButtons, setSelectedButtons] = useState([]);
    const [makedata, setMakeData] = useState([]);
    const [shaftdata, setShaftData] = useState([]);
    const [gripdata, setGripData] = useState([]);

    const [remortFittingFormData, setRemortFittingFormData] = useState(initData);

    const [buttonNames, setButtonNames] = useState([
        { id: 1, name: "Driver" },
        { id: 2, name: "3 Wood" },
        { id: 2, name: "4 Wood" },
        { id: 2, name: "5 Wood" },
        { id: 2, name: "7 Wood" },
        { id: 2, name: "9 Wood" },
        { id: 3, name: "2 Hybrid" },
        { id: 3, name: "3 Hybrid" },
        { id: 3, name: "4 Hybrid" },
        { id: 3, name: "5 Hybrid" },
        { id: 3, name: "6 Hybrid" },
        { id: 3, name: "7 Hybrid" },
        { id: 3, name: "8 Hybrid" },
        { id: 4, name: "1 Iron" },
        { id: 4, name: "2 Iron" },
        { id: 4, name: "3 Iron" },
        { id: 4, name: "4 Iron" },
        { id: 4, name: "5 Iron" },
        { id: 4, name: "6 Iron" },
        { id: 4, name: "7 Iron" },
        { id: 4, name: "8 Iron" },
        { id: 4, name: "9 Iron" },
        { id: 4, name: "PW" },
        { id: 5, name: "GW" },
        { id: 5, name: "SW" },
        { id: 5, name: "LW" },
        { id: 6, name: "Putter" }
    ]);

    const [options, setOptions] = useState([{ text: 'Unassigned', color: 'red', number: 0 }]);

    const [title, setTitle] = useState('');
    const [type_id, setType_id] = useState(0);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const closeDropdown = () => {
        setIsOpen(false);
    };

    const selectOption = (option) => {
        ////console.log(option.text);
        setSelectedOption(option.text);
        setselectedOptionsId(option.number);
    };

    const getAllStagingStations = async () => {
        return StagingStGet()
            .then((res) => {
                const Data = res.data.data;
                setStagingStations(Data);
            }).catch((err) => {
                alert(err);
            });
    };

    const getNonEmptyStagingStations = async () => {
        return getNonEmptyStations()
            .then((response) => {
                if (!response.data.status) {
                    setErrors(response.data.error);

                } else {
                    const Data = response.data.data;
                    setNonEmptyStagingStation(Data);
                }
            }).catch((err) => {
                console.error(err);
            }).finally(() => {
                // Optionally do something finally
            });
    };

    const getDataById = async () => {
        return getbuildsheet({ id: id })
            .then((res) => {
                if (res?.code === 200) {
                    const Data = res.data.data;
                    setBuildSheetNumber(Data.buildnumber);
                    setBuildSheetNumberNew(Data);
                    if (Data._id != undefined) {

                        setBuildSheetId(Data._id);
                        setselectedOptionsId(Data.station_Id);
                        setSelectedOption(Data.station_name);
                        setBuildstatus(Data.build_status);
                    }

                } else {
                    alert(res.data?.message);
                }
            }).catch((err) => {
                alert(err);
            });
    };

    const buildStGets = () => {
        let newOptions = '';

        const assignedStationIds = nonEmptyStagingStation.map(station => station.station_Id);
        if (nonEmptyStagingStation.length > 0) {
            const nonAssignedStations = StagingStations.filter(station => !assignedStationIds.includes(station.Staging_Stations_id));
            newOptions = nonAssignedStations.map(station => ({
                text: station.Staging_Stations_name,
                number: Number(station.Staging_Stations_id),
                color: "white"
            }));
        } else {
            // const nonAssignedStations = StagingStations.filter(station => !assignedStationIds.includes(station.Staging_Stations_id));
            newOptions = StagingStations.map(station => ({
                text: station.Staging_Stations_name,
                number: Number(station.Staging_Stations_id),
                color: "white"
            }));
        }


        setOptions(prevOptions => [
            { text: 'Unassigned', color: 'red', number: 0 },
            ...newOptions
        ]);
    }

    const getbuildSheetDataById = async () => {
        // setIsLoading(true);
        return getbuildsheetdata({ id: id })
            .then((res) => {
                if (res?.code === 200) {
                    const Data = res.data.data;
                    setBuildSheetData(Data);
                } else {
                    alert(res.data?.message);
                }
            }).catch((err) => {
                alert(err);
            }).finally(() => {
                // setIsLoading(false);
            });
    };


    const getRemortFittingDataById = () => {
        getremoteInquirydataApi({ id: id }).then((res) => {
            if (res?.code === 200) {
                const userData = res.data.data;
                console.log("userData", userData);
                setRemortFittingFormData(userData);
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    const handleupateprojectstatus = () => {
        setApicallUpate(true);
        const data = {
            'status': selectedOptionsId == 0 ? "0" : "1",
            'id': buildsheetid,
            'project_id': params.id,
            "user_id": userdata._id,
            "fitter_name": userdata.firstname + " " + userdata.lastname,
            "selectedOptionsId": selectedOptionsId,
            "station_name": selectedOption
        }
        upateBuildSheetStatus(data).then((res) => {
            ////console.log("res", res);
            if (!res.data.status) {
                setErrors(res.data.data);
                alert(res.data.data[0].detail);
            } else {
                setApicallUpate(false);
                getDataById();
                closeDropdown();
                // window.location.reload();
                //redirect to project view page
                window.location.href = `/project/staging-station/staging-station-view/${params.id}`;

            }

        }).catch((error) => {
            ////console.log("error", error);
        }).finally(() => {
            handleShow02();
        })
    }

    const openmodelpop = (name) => {

        var showname = "";

        setTitle(name);
        let parts = name.split(" ");
        if (parts.length > 1) {
            showname = parts[1];
        } else {
            showname = parts[0];
        }

        ////console.log("showname", showname);
        if (showname === "Driver" || showname === "Wood") {
            handleShow2();
            handleClose();
        }

        if (showname === "Hybrid") {
            handleShow3();
            handleClose();
        }

        if (showname === "Iron" || showname === "Wedge" || showname === "PW" || showname === "masterEntery") {
            handleShow4();
            handleClose();
        }

        if (showname === "Putter") {
            handleShow6();
            handleClose();
        }

        if (showname === "GW" || showname === "SW" || showname === "LW") {
            handleShow5();
            handleClose();
        }
    }

    useEffect(() => {
        if (closePopup === "driver&Wood") {
            handleClose2();
            getDataById();
            getbuildSheetDataById();
        }
        if (closePopup === "Hybrid") {
            handleClose3();
            getDataById();
            getbuildSheetDataById();
        }
        if (closePopup === "Iron&Wedge") {
            handleClose4();
            getDataById();
            getbuildSheetDataById();
        }
        if (closePopup === "Wedge") {
            handleClose5();
            getDataById();
            getbuildSheetDataById();
        }

        if (closePopup === "Putter") {
            handleClose6();
            getDataById();
            getbuildSheetDataById();
        }
        setClosePopup('');

    }, [closePopup])

    useEffect(() => {
        const getCurrentUserdata = getCurrentUser();
        // setUserdata(getCurrentUserdata.user);
        // setUser_id(getCurrentUserdata.user._id);


        if (getCurrentUserdata && getCurrentUserdata.user) {
            setUserdata(getCurrentUserdata.user);
        } else {
            console.error("Current user data is null or undefined");
        }
        getAllStagingStations();
        getNonEmptyStagingStations();
        getDataById();
        getbuildSheetDataById();
        getallModels();
        getRemortFittingDataById();
        getmakedata(0);
        getallmakedata(0);
        getprescriptionDataById();
        getprescriptiondata();
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        buildStGets();
    }, [StagingStations, nonEmptyStagingStation]);


    useEffect(() => {
        if (buildApiCall !== 0) {
            getbuildSheetDataById();
        }
    }, [buildApiCall])

    const getColorClass = () => {
        const selectedColor = options.find(opt => opt.text === selectedOption)?.color;
        return selectedColor ? `${selectedColor}` : 'white';
    };


    const getmakedata = (id) => {
        const data = {
            type_id: id
        }
        getInventoryByTypeWithShaftAndGrip(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setMakeData(data.makeData);
                setShaftData(data.shaftdata);
                setGripData(data.gripdata);
            }
        }
        ).catch((err) => {
            console.log(err);
        });
    }

    const [allmodels, setAllModels] = useState([]);

    const getallModels = () => {
        getallModeldatabymake().then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setAllModels(data);
            }
        }
        ).catch((err) => {
            console.log(err);
        });
    }


    useEffect(() => {
    }, [remortFittingFormData]);

    const [allMakeData, setallMakeData] = useState([]);
    const getallmakedata = (id) => {
        const data = {
            type_id: id
        }
        getInventoryByType(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setallMakeData(data);
            }
        }
        ).catch((err) => {
            console.log(err);
        });
    }



    const [SinglePrescription, setSinglePrescription] = useState(0);
    const getprescriptionDataById = () => {
        getsingleprescription({ project_id: id }).then((res) => {
            if (res?.code === 200) {
                const prescriptionData = res.data.data;
                setSinglePrescription(prescriptionData);
            } else {
                // alert(res.data?.message);
                console.log(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }


    const [prescription, setPrescription] = useState(initialPrescriptionState);

    const getprescriptiondata = () => {
        const data = {
            'project_id': id
        }
        getPrescription(data).then((res) => {
            if (!res.data.status) {
                console.log(res.data.data[0].detail);
            } else {
                setPrescription(res.data.data);
            }

        }).catch((error) => {
            console.log("error", error);
        });
    }



    useEffect(() => {

    }, [allMakeData]);

    const closeButton = () => {
        setShowinsight(false);
    }


    // const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 100) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleCloseConfirmation2 = () => setShowConfirmation2(false);
    const handleShowConfirmation2 = () => setShowConfirmation2(true);
    const [showConfirmation2, setShowConfirmation2] = useState(false);
    const [deleteloader, setDeleteLoader] = useState(false);

    const deletebuildsheetfunc = () => {
        handleCloseConfirmation2();
        setDeleteLoader(true);
        const data = {
            'project_id': id
        }
        deletebuildsheet(data).then((res) => {
            if (!res.data.status) {
                console.log(res.data.data[0].detail);
            } else {
                setDeleteLoader(false);
                window.location.href = `project/project-view/${id}`

            }

        }).catch((error) => {
            console.log("error", error);
        });
    }


    return (
        <>

            <Modal
                show={showConfirmation2}
                onHide={handleCloseConfirmation2}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <div className="logo-modal mb-4 text-center">
                        <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                    </div>
                    <div className="confirmation-content text-center">
                        <h4>Are you sure you want to remove a project?</h4>
                        <div className="confirmation-buttons d-flex align-items-center justify-content-between gap-2 mt-4">
                            <Button variant="success" onClick={deletebuildsheetfunc} style={{ maxWidth: "3.5rem" }}>
                                Yes
                            </Button>
                            {' '}
                            <Button variant="danger" onClick={() => {
                                handleCloseConfirmation2();
                            }} style={{ maxWidth: "3.5rem" }}>
                                No
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {
                remortFittingFormData.firstname != "" ? (
                    <>
                        {
                            isLoading ? (
                                <div className="loading">
                                    <Loader2 />
                                </div>
                            ) : (
                                <>
                                    {/* Driver + Wood Modal End Here  */}
                                    <Modal size="lg" centered show={show} onHide={handleClose} className="card-radius popup-modal-dark add_club_modal build_sheet_modal">
                                        <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                            <div className="close-modal">
                                                <div className="custom-modal-header">
                                                    <h3 className="text mb-5">Add Club</h3>
                                                    <button type="button" className="btn-close" onClick={handleClose} aria-label="Close">
                                                        <IoClose />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className='modal-select-btn'>
                                                <div className='select-btn-list '>
                                                    <div className='select-btn-item modal-btn-btn'>
                                                        <button
                                                            type="button"
                                                            className={`btn btn-primary btn-select ${selectedButtons.includes('4') ? 'selected' : ''}`}
                                                            onClick={() => {
                                                                openmodelpop('masterEntery');
                                                                getmakedata('4');
                                                                setType_id('4');
                                                            }
                                                            }
                                                        >
                                                            Master Entry
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className='select-btn-list'>
                                                    {buttonNames.map((item) => (
                                                        <div className='select-btn-item' key={item.id}>
                                                            <button
                                                                type="button"
                                                                className={`btn btn-primary btn-select ${selectedButtons.includes(item.id) ? 'selected' : ''}`}
                                                                onClick={() => {
                                                                    openmodelpop(item.name);
                                                                    getmakedata(item.id);
                                                                    setType_id(item.id);
                                                                }
                                                                }
                                                            >
                                                                {item.name}
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </Modal.Body>
                                    </Modal>

                                    <Modal
                                        show={show02}
                                        onHide={handleClose02}
                                        centered
                                        id="success_tic"
                                        className='model-thank-you'
                                    >
                                        <Modal.Body>
                                            <div className="custom-modal-header">
                                                <div className="logo-modal">
                                                    <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                                                </div>
                                                <div className="close-modal">
                                                    <button type="button" className="btn-close" onClick={handleClose02} aria-label="Close"> <IoClose /></button>
                                                </div>
                                            </div>
                                            <div className='modal-image'>
                                                <img src={require('../../assets/images/forewardFormSubmitClubOrder.png')} alt="logo" />
                                            </div>
                                            <h3 className="text-center mb-4">
                                                Your Project Update Successfully.
                                            </h3>
                                        </Modal.Body>
                                    </Modal>

                                    <div className="main-page-body-content-header">
                                        <HeaderAdmin />
                                    </div>

                                    {
                                        showinsight === true ? (
                                            <>
                                                <BuildsheetInsights id={id} closeButton={closeButton} />
                                            </>
                                        ) : (
                                            <>

                                                <div className='design_show_mobile'>
                                                    <div className='fixed-btn' >
                                                        <button onClick={handleShow} style={{ opacity: selectedOption !== 'Unassigned' ? '1' : '0.5' }} disabled={selectedOption !== 'Unassigned'}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="64.000000pt" height="64.000000pt" viewBox="0 0 64.000000 64.000000" preserveAspectRatio="xMidYMid meet">

                                                                <g transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                                                                    <path d="M586 628 c-3 -7 -15 -76 -27 -153 -12 -77 -25 -143 -28 -147 -3 -4 -87 11 -186 32 -207 45 -228 47 -274 22 -55 -29 -71 -71 -71 -182 0 -108 15 -145 72 -180 28 -17 51 -20 159 -20 142 0 193 12 252 61 62 51 77 94 118 338 21 124 38 226 36 227 -14 11 -48 13 -51 2z m-301 -367 c124 -27 130 -29 127 -51 -1 -13 -4 -25 -6 -27 -2 -2 -155 29 -253 52 -22 5 -31 33 -16 48 8 9 -3 11 148 -22z m-67 -97 c76 -16 82 -18 76 -38 -4 -12 -8 -23 -10 -25 -2 -2 -44 4 -94 15 -68 13 -89 21 -85 32 3 7 5 18 5 23 0 12 12 12 108 -7z" />
                                                                </g>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="buildsheetfix dashboard-container d-flex dashboard_light build_box_dashboard_sec inline-btn-dashboard">
                                                    <div className="main-container">
                                                        <div className="main-page-body-content">
                                                            <div className="main-page-body-content-body">
                                                                <div className="main-page-body-content-body-container">
                                                                    <div className="container-fluid">
                                                                        <div className="sec-header-new">
                                                                            <button type="button" className="btn-header-transparent">
                                                                                <div className="border_box_view">
                                                                                    <div className="border_box_view_inner">
                                                                                        <div className="box_icon">
                                                                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="64" viewBox="0 0 64 64" width="64"><g fill="#99ea24"><path d="m15 9c0-3.86599 3.134-7 7-7h15c3.866 0 7 3.13401 7 7 0 3.866-3.134 7-7 7h-15c-3.866 0-7-3.134-7-7z" /><path d="m13 9c0-.68739.0771-1.35678.223-2h-.223c-4.41828 0-8 3.5817-8 8v39c0 4.4183 3.58172 8 8 8h12v-21c0-4.9706 4.0294-9 9-9h20v-17c0-4.4183-3.5817-8-8-8h-.223c.1459.64322.223 1.31261.223 2 0 4.9706-4.0294 9-9 9h-15c-4.9706 0-9-4.0294-9-9z" /><path clip-rule="evenodd" d="m35.2143 34c-4.4699 0-8.2143 3.5162-8.2143 8v12c0 4.4838 3.7444 8 8.2143 8h15.5714c4.4699 0 8.2143-3.5162 8.2143-8v-12c0-4.4838-3.7444-8-8.2143-8zm2.7857 4h10v4c0 1.1046-.8954 2-2 2h-6c-1.1046 0-2-.8954-2-2z" fill-rule="evenodd" /></g></svg>
                                                                                        </div>
                                                                                        <div className="box_text_content">
                                                                                            <div className="big_text">Build Sheet</div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </button>
                                                                            <div className="header-left">



                                                                                {/* <Link to={`/project/buildsheet/buildsheet-insights/${params.id}`}> */}
                                                                                <button type="button" className="btn-header-transparent me-3" onClick={() => {
                                                                                    setShowinsight(true);
                                                                                }}>
                                                                                    <div className="border_box_view">
                                                                                        <div className="border_box_view_inner">
                                                                                            <div className="box_icon">
                                                                                                <svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" fill='#99ea24'><path d="m141 201h110v30h-110z" /><path d="m281 321h30v30h-30z" /><path d="m281 381h30v30h-30z" /><path d="m141 261h110v30h-110z" /><path d="m141 381h110v30h-110z" /><path d="m281 261h30v30h-30z" /><path d="m141 321h110v30h-110z" /><path d="m341 261h30v30h-30z" /><path d="m341 201h30v30h-30z" /><path d="m341 381h30v30h-30z" /><path d="m341 321h30v30h-30z" /><path d="m281 201h30v30h-30z" /><path d="m351 8.783v91.217h91.211z" /><path d="m336 130c-8.284 0-15-6.716-15-15v-115h-215c-24.813 0-45 20.187-45 45v422c0 24.813 20.187 45 45 45h300c24.813 0 45-20.187 45-45v-337zm65 296c0 8.284-6.716 15-15 15h-260c-8.284 0-15-6.716-15-15v-240c0-8.284 6.716-15 15-15h260c8.284 0 15 6.716 15 15z" /></svg>

                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </button>
                                                                                {/* </Link> */}

                                                                                <Link to={`/project/project-view/${params.id}`}>
                                                                                    <button type="button" className="btn-header-transparent me-3">
                                                                                        <div className="border_box_view">
                                                                                            <div className="border_box_view_inner">
                                                                                                <div className="box_icon">
                                                                                                    <svg xmlns="http://www.w3.org/2000/svg" clip-rule="evenodd" fill-rule="evenodd" height="512" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" width="512"><g id="Icon" fill='#99ea24'><path d="m15.479 22.75h-11.479c-.729 0-1.429-.29-1.945-.805-.515-.516-.805-1.216-.805-1.945v-16c0-.729.29-1.429.805-1.945.516-.515 1.216-.805 1.945-.805h8.586c.464 0 .909.184 1.237.513l4.414 4.414c.329.328.513.773.513 1.237v4.151c-.687-.101-1.386-.084-2.068.05-.575.112-1.055.505-1.28 1.046l-.17.41c-.224-.029-.441-.057-.441-.057-.581-.076-1.161.143-1.546.585-.521.598-.922 1.291-1.179 2.042-.19.554-.09 1.166.266 1.631l.271.353c-.137.179-.271.353-.271.353-.356.465-.456 1.077-.266 1.631.257.751.658 1.444 1.179 2.042.385.442.965.661 1.546.585l.441-.057c.086.208.17.41.17.41.023.055.049.109.077.161zm-9.979-8h4.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-4.5c-.414 0-.75.336-.75.75s.336.75.75.75zm7-11.75v3.5c0 .552.448 1 1 1h3.5zm-7 8.25h8c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-8c-.414 0-.75.336-.75.75s.336.75.75.75zm0 7h4.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-4.5c-.414 0-.75.336-.75.75s.336.75.75.75z" /><path d="m19.396 13.044s.355.855.354.855c.135.068.266.144.393.226l.918-.12c.248-.032.497.062.662.251.436.5.771 1.081.987 1.709.081.237.038.5-.115.699 0 0-.562.735-.562.734.008.151.008.303 0 .453l.562.735c.153.199.196.462.115.699-.216.628-.551 1.209-.987 1.709-.165.189-.414.283-.662.251 0 0-.918-.12-.917-.121-.127.083-.259.159-.393.227l-.355.855c-.096.232-.302.4-.548.448-.652.128-1.322.128-1.974 0-.246-.048-.452-.216-.548-.448 0 0-.355-.855-.354-.855-.135-.068-.267-.144-.393-.226l-.918.12c-.249.032-.497-.062-.662-.251-.437-.5-.772-1.081-.987-1.709-.081-.237-.038-.5.114-.699 0 0 .563-.735.563-.734-.008-.151-.008-.303 0-.453l-.563-.735c-.152-.199-.195-.462-.114-.699.215-.628.55-1.209.987-1.709.165-.189.413-.283.662-.251 0 0 .918.12.917.121.127-.083.258-.159.393-.227l.355-.855c.096-.232.302-.4.548-.448.652-.128 1.322-.128 1.974 0 .246.048.452.216.548.448zm-1.535 3.081c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5z" /></g></svg>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </button>
                                                                                </Link>
                                                                                <button type="button" className="btn-header-transparent close-icon" onClick={goBack}>
                                                                                    <div className="border_box_view">
                                                                                        <div className="border_box_view_inner">
                                                                                            <div className="box_icon">
                                                                                                <IoCloseSharp />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        <div className="dashboard-sec">
                                                                            <div className="row">
                                                                                <div className="col-lg-8 col-md-12 col-sm-12 order-md-2 order-sm-2 order-2 dashboard_2 study_guide_open db_col design_hide_mobile">
                                                                                    <BuildAccordion buildsheets={buildsheetdata} ondeleteChange={(deleteid) => setBuildApiCall(deleteid)} selectedOptions={selectedOption} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                                                                                    <>
                                                                                        <div className="btn-box-section btn-inline-box">
                                                                                            {
                                                                                                deleteloader ? (<button className="btn btn-primary btn-remove" disabled>Removing....</button>) : (<button className="btn btn-primary btn-remove" onClick={handleShowConfirmation2}>Remove Build</button>)
                                                                                            }

                                                                                        </div>
                                                                                    </>
                                                                                </div>
                                                                                <div className={`col-lg-4 col-md-12 col-sm-12 order-md-1 order-sm-1 order-1 dashboard_first right_fix_sec ${scrolled ? 'tab_fix' : ''}`}>
                                                                                    <div className="fix_sec_view container-fluid ps-0">
                                                                                        <div className="btn-box-section mt-0 design_hide_mobile">
                                                                                            <button className="btn btn-primary btn-create" onClick={handleShow} disabled={selectedOption !== 'Unassigned'}>Add Club</button>
                                                                                        </div>
                                                                                        <div className='select-dropdown-build'>
                                                                                            {
                                                                                                buildsheetdata && buildsheetdata.length > 0 ? (
                                                                                                    <div className={`select-options-dropdown ${isOpen ? 'open' : ''}`}>
                                                                                                        {/* <div className='select-option-inner' onClick={toggleDropdown}> */}
                                                                                                        <div className='select-option-inner' onClick={!buildstatus ? toggleDropdown : null}>
                                                                                                            <div className='select-options-icon'>
                                                                                                                <span className={`icon-color color-${getColorClass()}`}>{selectedOptionsId == '0' ? '' : selectedOptionsId}</span>
                                                                                                            </div>
                                                                                                            <div className='selected-option-text'>
                                                                                                                {selectedOption}
                                                                                                            </div>
                                                                                                            <span className={`icon ${isOpen ? 'up' : 'down'}`}>
                                                                                                                <i className="bi bi-chevron-down" />
                                                                                                            </span>
                                                                                                        </div>

                                                                                                        {isOpen && (

                                                                                                            <div className='option-list buildsheet-option-list'>

                                                                                                                <div className='drop-down-list'>
                                                                                                                    {options.map(option => (
                                                                                                                        <div
                                                                                                                            key={option.text}
                                                                                                                            className={`drop-down-item ${selectedOptionsId === option.number ? 'active' : ''}`}
                                                                                                                            onClick={() => selectOption(option)}
                                                                                                                        >
                                                                                                                            <div className='drop-down-item-icon'>
                                                                                                                                <span className={`icon-color color-${option.color}`}>{option.number == '0' ? '' : option.number}</span>
                                                                                                                            </div>
                                                                                                                            <div className='drop-down-item-text'>{option.text}</div>
                                                                                                                        </div>
                                                                                                                    ))}
                                                                                                                </div>

                                                                                                                <div className='form-box-section'>
                                                                                                                    {
                                                                                                                        selectedOptionsId == '0' ? (
                                                                                                                            <button
                                                                                                                                className="btn btn-primary btn-create"
                                                                                                                                disabled
                                                                                                                            >
                                                                                                                                <span>Update Status</span>
                                                                                                                            </button>
                                                                                                                        ) : (

                                                                                                                            <button
                                                                                                                                className="btn btn-primary btn-create"
                                                                                                                                onClick={() => {
                                                                                                                                    handleupateprojectstatus();
                                                                                                                                }}
                                                                                                                            >
                                                                                                                                {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Update Status</span>)}
                                                                                                                            </button>
                                                                                                                        )
                                                                                                                    }
                                                                                                                </div>




                                                                                                            </div>

                                                                                                        )}
                                                                                                    </div>
                                                                                                )
                                                                                                    : (
                                                                                                        <div className={`select-options-dropdown ${isOpen ? 'open' : ''}`}>
                                                                                                            <div className='select-option-inner' >
                                                                                                                <div className='select-options-icon'>


                                                                                                                    <span className={`icon-color color-red`}>{selectedOptionsId == '0' ? '' : selectedOptionsId}</span>


                                                                                                                </div>
                                                                                                                <div className='selected-option-text'>
                                                                                                                    {selectedOption}
                                                                                                                </div>
                                                                                                                <span className={`icon ${isOpen ? 'up' : 'down'}`}>
                                                                                                                    <i className="bi bi-chevron-down" />
                                                                                                                </span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    )
                                                                                            }

                                                                                        </div>

                                                                                        {
                                                                                            allMakeData && allMakeData.length > 0 ? (
                                                                                                <>
                                                                                                    <div className="design_hide_mobile">
                                                                                                        <BuildTab project_id={params.id} project_step="buildsheet" currentpagename="buildsheet" buildsheets={buildsheetdata} ondeleteChange={(deleteid) => setBuildApiCall(deleteid)} allmodels={allmodels} remortFittingFormData={remortFittingFormData} allMakeData={allMakeData} SinglePrescription={SinglePrescription} prescriptioncalc={prescription} />
                                                                                                    </div>
                                                                                                    <div className='design_show_mobile'>
                                                                                                        <BuildTabBuildsheet project_id={params.id} project_step="buildsheet" currentpagename="buildsheet" buildsheets={buildsheetdata} ondeleteChange={(deleteid) => setBuildApiCall(deleteid)} allmodels={allmodels} StagingStations={StagingStations} remortFittingFormData={remortFittingFormData} nonEmptyStagingStation={nonEmptyStagingStation} allMakeData={allMakeData} prescriptioncalc={prescription} buildsheetnumber={buildsheetnumbernew} />
                                                                                                    </div>
                                                                                                </>
                                                                                            ) : (
                                                                                                <></>
                                                                                            )
                                                                                        }

                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    }



                                    {/* Driver + Wood Modal Start Here */}
                                    <Modal size="lg" show={show2} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                                        <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                            <div className="close-modal">
                                                <div className="custom-modal-header">
                                                    <h3 className="text mb-5">{title}</h3>
                                                    <button type="button" className="btn-close" onClick={handleClose2} aria-label="Close">
                                                        <IoClose />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="modal-long-form">
                                                <DriverWood project_id={id} title={title} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} makedata={makedata} type_id={type_id} shaftdata={shaftdata} gripdata={gripdata} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                                            </div>
                                        </Modal.Body>
                                    </Modal>

                                    {/* Hybrid Modal Start Here */}
                                    <Modal size="lg" show={show3} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                                        <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                            <div className="close-modal">
                                                <div className="custom-modal-header">
                                                    <h3 className="text mb-5">{title}</h3>
                                                    <button type="button" className="btn-close" onClick={handleClose3} aria-label="Close">
                                                        <IoClose />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="modal-long-form">
                                                <Hybrid project_id={id} title={title} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} makedata={makedata} type_id={type_id} shaftdata={shaftdata} gripdata={gripdata} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                                            </div>
                                        </Modal.Body>
                                    </Modal>
                                    {/* Hybrid Modal End Here  */}

                                    {/* Iron + Wedge Start Here */}
                                    <Modal size="lg" show={show4} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                                        <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                            <div className="close-modal">
                                                <div className="custom-modal-header">
                                                    <h3 className="text mb-5">{title === 'masterEntery' ? "7 Iron" : title}</h3>
                                                    <button type="button" className="btn-close" onClick={handleClose4} aria-label="Close">
                                                        <IoClose />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="modal-long-form">
                                                <IronWedge project_id={id} title={title} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} makedata={makedata} type_id={type_id} shaftdata={shaftdata} gripdata={gripdata} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                                            </div>
                                        </Modal.Body>
                                    </Modal>
                                    {/* Iron + Wedge End Here  */}

                                    {/* Wedge Start Here */}
                                    <Modal size="lg" show={show5} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                                        <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                            <div className="close-modal">
                                                <div className="custom-modal-header">
                                                    <h3 className="text mb-5">{title}</h3>
                                                    <button type="button" className="btn-close" onClick={handleClose5} aria-label="Close">
                                                        <IoClose />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="modal-long-form">
                                                <Wedge project_id={id} title={title} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} makedata={makedata} type_id={type_id} shaftdata={shaftdata} gripdata={gripdata} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                                            </div>
                                        </Modal.Body>
                                    </Modal>
                                    {/* Wedge End Here  */}

                                    {/* Putter Start Here */}
                                    <Modal size="lg" show={show6} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                                        <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                            <div className="close-modal">
                                                <div className="custom-modal-header">
                                                    <h3 className="text mb-5">{title}</h3>
                                                    <button type="button" className="btn-close" onClick={handleClose6} aria-label="Close">
                                                        <IoClose />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="modal-long-form">
                                                <Putter project_id={id} title={title} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} makedata={makedata} type_id={type_id} shaftdata={shaftdata} gripdata={gripdata} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                                            </div>
                                        </Modal.Body>
                                    </Modal>
                                    {/* Putter End Here  */}
                                    <style>
                                        {
                                            `
                                .unique .modal-dialog{
                                    max-width: 100% !important;
                                     width: 100% !important;
                                     margin: 0 !important;
                                }
                                `
                                        }
                                    </style>
                                </>
                            )
                        }
                    </>) : (<> </>)
            }
        </>





    );
}

export default UnassignedBuildSheet;